var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6348_97019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.23438 2.93984L10.9467 0.644531L18.7702 2.93984L10.9467 5.05703L3.23438 2.93984Z",
    stroke: "#F7A303",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9108 3.71436V8.08295H13.2541C11.9875 8.08295 10.9608 9.1102 10.9608 10.3774C10.9608 9.1102 9.93397 8.08295 8.66743 8.08295H5.98828V3.71436",
    stroke: "#F7A303",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8291 19.3493C15.4854 19.3493 16.0175 18.8172 16.0175 18.1608C16.0175 17.5045 15.4854 16.9724 14.8291 16.9724C14.1727 16.9724 13.6406 17.5045 13.6406 18.1608C13.6406 18.8172 14.1727 19.3493 14.8291 19.3493Z",
    stroke: "#F7A303",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.165 21.3554C20.8213 21.3554 21.3534 20.8233 21.3534 20.1669C21.3534 19.5106 20.8213 18.9785 20.165 18.9785C19.5086 18.9785 18.9766 19.5106 18.9766 20.1669C18.9766 20.8233 19.5086 21.3554 20.165 21.3554Z",
    stroke: "#F7A303",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0195 18.1607V12.2432L21.3562 13.6953V20.167",
    stroke: "#F7A303",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.644531 15.4208C0.644531 14.0293 1.7698 12.9014 3.1579 12.9014C4.22606 12.9014 5.13842 13.5693 5.50236 14.5112C5.86627 13.5693 6.77866 12.9014 7.84682 12.9014C9.38403 12.8988 10.382 14.0976 10.3535 15.6111C10.2859 19.2048 5.50069 21.3557 5.50069 21.3557C5.4569 21.3492 0.644531 19.2916 0.644531 15.4208Z",
    stroke: "#F7A303",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6348_97019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/Events.04525e79ab8ab4689e6d84de166e5a03.svg";
export { ForwardRef as ReactComponent };